import { api_configuration } from "../../common";
import { IdPathBuilder } from "../navigation/IdPathBuilder";
import client_request = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.client_request.alan_api;
import client_reply = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.client_reply.alan_api;
import client_state = api_configuration.types.client_state.alan_api;

function doMapClientRequest(id: client_request.Cid_path__client_request, builder: IdPathBuilder): IdPathBuilder {
	switch (id.properties.has_steps.state.name) {
		case "no":
			return builder;
		case "yes": {
			const tail = id.properties.has_steps.state.node.properties.tail;
			const type = id.properties.has_steps.state.node.properties.type;
			switch (type.state.name) {
				case "collection entry":
					return doMapClientRequest(
						tail,
						builder.collectionEntry(type.state.node.properties.collection.entry, type.state.node.properties.id)
					);
				case "group":
					return doMapClientRequest(tail, builder.group(type.state.node.properties.group.entry));
				case "state":
					return doMapClientRequest(
						tail,
						builder.state(type.state.node.properties.state_group.entry, type.state.node.properties.state.entry)
					);
				default:
					return unexpectedState(type.state);
			}
		}
		default:
			return unexpectedState(id.properties.has_steps.state);
	}
}

function doMapClientReply(id: client_reply.Cid_path__client_reply, builder: IdPathBuilder): IdPathBuilder {
	switch (id.properties.has_steps.state.name) {
		case "no":
			return builder;
		case "yes": {
			const tail = id.properties.has_steps.state.node.properties.tail;
			const type = id.properties.has_steps.state.node.properties.type;
			switch (type.state.name) {
				case "collection entry":
					return doMapClientReply(
						tail,
						builder.collectionEntry(type.state.node.properties.collection.entry, type.state.node.properties.id)
					);
				case "group":
					return doMapClientReply(tail, builder.group(type.state.node.properties.group.entry));
				case "state":
					return doMapClientReply(
						tail,
						builder.state(type.state.node.properties.state_group.entry, type.state.node.properties.state.entry)
					);
				default:
					return unexpectedState(type.state);
			}
		}
		default:
			return unexpectedState(id.properties.has_steps.state);
	}
}

function doMapClientState(id: client_state.Cid_path, builder: IdPathBuilder): IdPathBuilder {
	switch (id.properties.has_steps.state.name) {
		case "no":
			return builder;
		case "yes": {
			const tail = id.properties.has_steps.state.node.properties.tail;
			const type = id.properties.has_steps.state.node.properties.type;
			switch (type.state.name) {
				case "collection entry":
					return doMapClientState(
						tail,
						builder.collectionEntry(type.state.node.properties.collection.entry, type.state.node.properties.id)
					);
				case "group":
					return doMapClientState(tail, builder.group(type.state.node.properties.group.entry));
				case "state":
					return doMapClientState(
						tail,
						builder.state(type.state.node.properties.state_group.entry, type.state.node.properties.state.entry)
					);
				default:
					return unexpectedState(type.state);
			}
		}
		default:
			return unexpectedState(id.properties.has_steps.state);
	}
}

export function fromClientRequest(id: client_request.Cid_path__client_request): IdPathBuilder {
	return doMapClientRequest(id, IdPathBuilder.create());
}

export function fromClientReply(id: client_reply.Cid_path__client_reply): IdPathBuilder {
	return doMapClientReply(id, IdPathBuilder.create());
}

export function fromClientState(id: client_state.Cid_path): IdPathBuilder {
	return doMapClientState(id, IdPathBuilder.create());
}
